// import TotalReducer from "./items/Total";
import PersonalDetails from "./items/PersonalDetails";
import ThankYouReducer from "./items/ThankYou";
import ThankYouDetailsReducer from "./items/ThankYouDetails";
import Language from "./items/Language";
import BookingListReducer from "./items/BookingList";
import PageLoadingReducer from "./items/PageLoading";
import BookingListDeviceReducer from "./items/BookingListDevice";
import TotoPlaceBetReducer from "./items/TotoPlaceBet";
// import TotoDrawDateReducer from "./items/TotoDrawDate";
import TotoPlaceBetFinalReducer from "./items/TotoPlaceBetFinal";
import TotoThankYouReducer from "./items/TotoThankYou";
import ReferLogin from "./items/ReferLogin";
import LoginReducer from "./items/LoginReducer";
import TotoTotalReducer from "./items/TotoTotal";
import DepositWithdrawalReducer from "./items/DepositWithdrawal";
import FourDPrize from "./items/FourDPrize";
import DialogLogin from "./items/DialogLogin";

// import DrawReducer from "./items/Draw";

// import PlaceBetReducer from "./items/PlaceBet";
// import PlaceBetFinalReducer from "./items/PlaceBetFinal";

import FourDPlaceBet from "./items/FourDPlaceBet";
// import FourDPlaceBetFinal from "./items/FourDPlaceBetFinal";
import FourDCompute from "./items/FourDCompute";

import DrawSet from "./items/DrawSet";
import Maintenance from "./items/Maintenance";
import PopUp from "./items/PopUp";

const rootReducers = {
	drawSet: DrawSet,
	fourDPrize: FourDPrize,

	// draw: DrawReducer,
	// placeBet: PlaceBetReducer,
	// betSlip: PlaceBetFinalReducer,
	fourDPlaceBet: FourDPlaceBet,
	// fourDPlaceBetFinal: FourDPlaceBetFinal,
	fourDCompute: FourDCompute,
	// total: TotalReducer,
	personalDetails: PersonalDetails,
	thankYouBet: ThankYouReducer,
	ThankYouDetails: ThankYouDetailsReducer,
	Language: Language,
	bookingList: BookingListReducer,
	deviceBookingList: BookingListDeviceReducer,
	pageLoading: PageLoadingReducer,
	totoPlaceBet: TotoPlaceBetReducer,
	// totoDrawDate: TotoDrawDateReducer,
	totoPlaceBetFinal: TotoPlaceBetFinalReducer,
	totoThankYou: TotoThankYouReducer,
	referLogin: ReferLogin,
	login: LoginReducer,
	TotoTotal: TotoTotalReducer,
	DepositWithdrawal: DepositWithdrawalReducer,
	Maintenance: Maintenance,
	DialogLogin: DialogLogin,
	PopUp: PopUp,
};

export default rootReducers;
